import type { Ref } from 'react';
import React, { forwardRef } from 'react';

import { makeStyles } from 'tss-react/mui';

import type { ColorSelectFunction } from './ColorSelectComponent';
import { ColorSelectMenuColor } from './ColorSelectMenuColor';

const useStyles = makeStyles()(() => ({
  colorRow: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

interface ColorSelectMenuColumnProps {
  colors: string[];
  selectColor: ColorSelectFunction;
  selectedColor: string | null;
}

export const ColorSelectMenuColumn = forwardRef(function ColorSelectMenuColumn(
  { colors, selectColor, selectedColor }: ColorSelectMenuColumnProps,
  ref: Ref<HTMLDivElement>
): JSX.Element {
  const { classes } = useStyles();

  return (
    <div ref={ref} className={classes.colorRow}>
      {colors.map((color: string, index: number) => (
        <ColorSelectMenuColor
          key={index}
          color={color}
          selectColor={selectColor}
          selectedColor={selectedColor}
        />
      ))}
    </div>
  );
});
